import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import ScaleLoader from "react-spinners/ScaleLoader"
import swal from "sweetalert"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { GLOBAL_CONSTANTS } from "../../constants/constants"
import { RootState } from "../../store"
import { loadDispatchs, loadShippingCompany, printMenifest } from "../../store/dispatch.store"
import Card from "../Layout/Card"
import Header from "../Layout/Header"
import DispatchTable from "./DispatchTable"

const Dispatchs = () => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()
    const { userInfo } = useAppSelector((state: RootState) => state.auth)
    const { shippingcompany, dispatchs, loading } = useAppSelector((state: RootState) => state.dispatchs)
    const { selectedWarehouse } = useAppSelector((state: RootState) => state.warehouses)
    const [company, setCompany] = useState(GLOBAL_CONSTANTS.COMPANY)
    const [selectedRows, setSelectedRows] = useState([] as any)
    const [printLoading, setPrintLoading] = useState(false)
    const companyChange = (companyParam: string) => {
        setCompany(companyParam)
    }

    const defaultWarehouse = userInfo?.ParcelHubUserWarehouse?.find(
        (uw: Record<string, any>) => uw?.is_default
    )?.warehouse_id

    const handleBtnClick = async () => {
        // dispatch(printMenifest({ "parcels": selectedRows }))
        var printParcel: any = await dispatch(printMenifest({ parcels: selectedRows }))
        if (printParcel?.payload?.data && printParcel?.payload?.data?.status === true) {
            setPrintLoading(false)
            if (printParcel?.payload?.data?.payload?.mainifest) {
                let url = printParcel?.payload?.data?.payload?.mainifest
                window.open(url, "_blank")
            }
            swal({
                title: "",
                text: t("Parcel_dispatched"),
                icon: "success"
            }).then(function () {
                dispatch(loadDispatchs({ company, warehouse: selectedWarehouse?.toString() }))
            })
        } else {
            swal({
                title: "",
                text: t("Parcel_Not_dispatched"),
                icon: "error"
            }).then(function () {
                dispatch(loadDispatchs({ company, warehouse: selectedWarehouse?.toString() }))
            })
        }
    }

    const handleOnSelect = (row: any, isSelect: boolean) => {
        if (isSelect) {
            setSelectedRows([...selectedRows, row.uuid])
        } else {
            const index = selectedRows.indexOf(row.uuid)
            if (index > -1) {
                selectedRows.splice(index, 1)
            }
            setSelectedRows(selectedRows)
        }
    }

    const handleOnSelectAll = (isSelect: boolean, rows: any) => {
        const ids = rows.map((r: { id: any }) => r.id)
        if (isSelect) {
            setSelectedRows(ids)
        } else {
            setSelectedRows([])
        }
    }

    useEffect(() => {
        if (dispatchs.length === 0) {
            dispatch(loadDispatchs({ company, warehouse: selectedWarehouse?.toString() }))
        }
        dispatch(
            loadShippingCompany(
                selectedWarehouse ? selectedWarehouse?.toString() : defaultWarehouse?.toString()
            )
        )
    }, [selectedWarehouse])

    useEffect(() => {
        dispatch(loadDispatchs({ company, warehouse: selectedWarehouse?.toString() }))
    }, [company, selectedWarehouse])

    return (
        <>
            {loading || !userInfo?.accessToken ? (
                <div className="loader row justify-content-center">
                    <ScaleLoader color="#15397F" width={4} height={40} />
                </div>
            ) : (
                <div className="dispatched-container">
                    <Header
                        title={t("Dispatch")}
                        records={dispatchs?.length}
                        data={dispatchs}
                        name="Dispatch"
                        buttonId=".dispatchExportButton">
                        {/* <div className="mx-2">
							<DateRangePickerCustom setStartDate={setStartDate} setEndDate={setEndDate}  startDate={startDate} endDate={endDate} />
						</div> */}
                    </Header>

                    <div className="row justify-content-around mt-5 ">
                        {shippingcompany.length > 0 &&
                            shippingcompany?.map((shippingCompany: any) => (
                                <div
                                    className={
                                        parseInt(company) === shippingCompany?.id
                                            ? "col-lg-2 col-md-2 col-sm-12 shipping_dispatch company_selected"
                                            : "col-lg-2 col-md-2 col-sm-12 shipping_dispatch"
                                    }>
                                    <Card
                                        logo={shippingCompany?.logo}
                                        name={shippingCompany?.shipping_name}
                                        companyChange={companyChange}
                                        companyId={shippingCompany?.id}
                                    />
                                </div>
                            ))}
                    </div>
                    <div className="row  d-flex">
                        <DispatchTable
                            dispatch={dispatchs}
                            handleOnSelect={handleOnSelect}
                            handleOnSelectAll={handleOnSelectAll}
                            handleBtnClick={handleBtnClick}
                            selectedRows={selectedRows}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default Dispatchs
